import { render, staticRenderFns } from "./MessageDetails.vue?vue&type=template&id=0757e721&"
import script from "./MessageDetails.vue?vue&type=script&lang=js&"
export * from "./MessageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports